































import Vue from 'vue'
import { ENDPOINTS } from '@/checkout/constants'
import httpClient from '@/common/httpClient'
import { ZipCodeType } from '@/types'
import { extractAddress, validateZipCode } from '@/product/utils'
export default Vue.extend({
  name: 'ZipCodeInput',
  components: {
  },
  props: {
    zipCode: {
      type: String,
      required: true
    },
    error: {
      type: String,
      required: true
    }
  },
  data(): {
    address: string
  } {
    return {
      address: ''
    }
  },
  computed: {
    showingAddress(): boolean {
      return this.address !== '' && this.error === ''
    }
  },
  methods: {
    extractAddress,
    resetAddress() {
      this.address = ''
      this.$emit('updateAddress', '')
    },
    filterZipcode(zipcode: string) {
      return zipcode.replace(/\D/g, '')
    },
    input(event: any) {
      this.$emit('input', this.filterZipcode(event.target.value))
    },
    onEnterSearch() {
      this.$emit('enter')
    },
    async searchAddress() {
      const validateZipcodeError = validateZipCode(this.zipCode)
      if (validateZipcodeError) {
        this.resetAddress()
        this.$emit('onError', validateZipcodeError)
        return
      }
      const res = await httpClient.get<ZipCodeType>(
        ENDPOINTS.ZIPCODE.replace(/%zipcode/, this.zipCode)
        )
        .catch(() => {
          this.resetAddress()
          this.$emit('onError', '郵便番号は不正な値です')
        })

      if (!res?.data) return

      const { data } = res
      this.address = this.extractAddress(data)
      this.$emit('onError', '')
      this.$emit('updateAddress', this.address)
    }
  }
})
